module.exports = __webpack_public_path__ + "img/qr-scan.07e19500.png";